import {
  type CommonNavigatorParams,
  type NativeStackScreenProps,
} from '#/lib/routes/types'
import {nameSegmentToIdentifier} from '#/lib/strings/profile-path'
import {makeRecordUri} from '#/lib/strings/url-helpers'
import {PostThread} from '#/screens/PostThread'
import * as Layout from '#/components/Layout'

type Props =
  | NativeStackScreenProps<CommonNavigatorParams, 'PostThread'>
  | NativeStackScreenProps<CommonNavigatorParams, 'PostByName'>
export function PostThreadScreen({route}: Props) {
  const {rkey} = route.params
  const name =
    route.name === 'PostByName'
      ? // AtUri throws synchronously on an empty/malformed host, so an
        // unresolvable segment falls back to the same sentinel
        // isInvalidHandle() already recognizes, rather than '' - the
        // resulting failed resolution is handled the same way any other
        // nonexistent handle already is.
        (nameSegmentToIdentifier(route.params.name) ?? 'handle.invalid')
      : route.params.name
  const uri = makeRecordUri(name, 'app.bsky.feed.post', rkey)

  return (
    <Layout.Screen testID="postThreadScreen">
      <PostThread uri={uri} />
    </Layout.Screen>
  )
}
